import * as React from "react";

import ApolloMutation from "~/data-access/gql/apollo-mutation.tsx";

import {FORGOT_PASSWORD_MUTATION} from "./forgot-password-mutation-query.ts";

interface ForgotPasswordResultData {
    error?:
        | {
              code: string;
          }
        | null
        | undefined;
}

interface ForgotPasswordResult {
    isLoading: boolean;
    isError: boolean;
    data: ForgotPasswordResultData | null | undefined;
}

interface Props {
    children: (
        submitForgotPassword: (email: string) => void,
        result: ForgotPasswordResult,
    ) => React.ReactNode;
}

export default function ForgotPasswordMutation({children}: Props) {
    return (
        <ApolloMutation mutation={FORGOT_PASSWORD_MUTATION}>
            {(sendForgotPasswordLink, {data, loading, error}) => {
                return children(
                    (email: string) => {
                        sendForgotPasswordLink({variables: {email}});
                    },
                    {
                        isLoading: loading,
                        isError: !!error,
                        data: data && {
                            error: data.forgotPassword?.error,
                        },
                    },
                );
            }}
        </ApolloMutation>
    );
}
